var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 23,
    viewBox: "0 0 13 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2488 0.00478553L9.26626 0C5.91546 0 3.75003 2.22168 3.75003 5.66033V8.27012H0.751204C0.49207 8.27012 0.282227 8.48021 0.282227 8.73934V12.5206C0.282227 12.7798 0.49231 12.9896 0.751204 12.9896H3.75003V22.531C3.75003 22.7902 3.95987 23 4.21901 23H8.13162C8.39075 23 8.6006 22.7899 8.6006 22.531V12.9896H12.1069C12.3661 12.9896 12.5759 12.7798 12.5759 12.5206L12.5773 8.73934C12.5773 8.61492 12.5278 8.49576 12.44 8.40771C12.3522 8.31965 12.2325 8.27012 12.1081 8.27012H8.6006V6.05777C8.6006 4.99442 8.85399 4.45462 10.2391 4.45462L12.2483 4.4539C12.5072 4.4539 12.7171 4.24381 12.7171 3.98491V0.473768C12.7171 0.21511 12.5075 0.00526409 12.2488 0.00478553Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.72e2ba4d5274c22344386a367c178a5f.svg";
export { ForwardRef as ReactComponent };